/*
 * Baksteendirect — B2B quantity logic
 * ----------------------------------------------------------------------------
 * Dependency-free. Reads minimum-order-quantity (MOQ) rules from data attributes
 * on the quantity input and enforces them:
 *   - data-min  : minimum orderable quantity (from product.metafields.custom.te_bestellen_per)
 *   - data-step : step / multiple the quantity must round up to
 *
 * Behaviour:
 *   - Mirrors data-min/data-step onto the native min/step attributes.
 *   - On 'change' and 'blur', rounds the value UP to the nearest valid step that
 *     is also >= min.
 *
 * Safe no-op when the attributes are absent or invalid. Exposes a single global
 * initialiser (window.B2BQuantity.init) so it can be re-run after AJAX section
 * re-renders (e.g. variant change, cart update).
 */
(function () {
  'use strict';

  var SELECTOR = 'input[data-b2b-min], input[data-b2b-step]';
  var INIT_FLAG = 'b2bQuantityBound';

  function toPositiveInt(value) {
    var n = parseInt(value, 10);
    return isNaN(n) || n < 1 ? null : n;
  }

  // Round `value` up to the nearest multiple of `step`, never below `min`.
  function snap(value, min, step) {
    var current = parseInt(value, 10);
    if (isNaN(current) || current < 0) {
      current = 0;
    }

    var floor = min || step || 1;

    // Empty / below minimum -> snap to the minimum allowed quantity.
    if (current < floor) {
      return floor;
    }

    if (step && step > 1 && current % step !== 0) {
      var stepped = Math.ceil(current / step) * step;
      // Guarantee the stepped value still respects the minimum.
      return stepped < floor ? floor : stepped;
    }

    return current;
  }

  function enforce(input) {
    var min = toPositiveInt(input.getAttribute('data-b2b-min'));
    var step = toPositiveInt(input.getAttribute('data-b2b-step'));

    // Nothing to enforce — leave the input exactly as Dawn set it.
    if (!min && !step) {
      return;
    }

    var adjusted = snap(input.value, min, step);
    if (String(adjusted) !== String(input.value)) {
      input.value = adjusted;
      // Let Dawn's quantity-input / cart listeners react to the corrected value.
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function bind(input) {
    if (input[INIT_FLAG]) {
      return;
    }

    var min = toPositiveInt(input.getAttribute('data-b2b-min'));
    var step = toPositiveInt(input.getAttribute('data-b2b-step'));

    // No MOQ rules present -> do not bind anything (true no-op).
    if (!min && !step) {
      return;
    }

    // Mirror the rules onto the native attributes for built-in stepper / a11y.
    var floor = min || step;
    if (floor) {
      input.min = floor;
    }
    if (step && step > 1) {
      input.step = step;
    }

    var handler = function () {
      enforce(input);
    };

    input.addEventListener('change', handler);
    input.addEventListener('blur', handler);
    input[INIT_FLAG] = true;
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var inputs = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      bind(inputs[i]);
    }
  }

  window.B2BQuantity = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
